exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".categories__option__2GZ1t,.categories__options__35IOB{width:100%}.categories__option__2GZ1t{display:block;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports
exports.locals = {
	"option": "categories__option__2GZ1t",
	"options": "categories__options__35IOB"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/components/categories/categories.styl
// module id = 2905
// module chunks = 1